"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dot = exports.BulletContainer = exports.DotView = exports.Image = exports.PaginationView = exports.scrollbarContainer = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.scrollbarContainer = native_1.default.View `
  min-width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
exports.PaginationView = native_1.default.View `
  flex-direction: column,
  justify-content: 'space-between',
  width: 100,
  alignSelf: center,
`;
exports.Image = native_1.default.Image `
  width: 350px;
  height: 350px;
`;
exports.DotView = native_1.default.View `
  flex: 1;
  justify-content: center;
  flex-direction: row;
`;
exports.BulletContainer = native_1.default.View `
  bottom: 0;
  justify-content: center;
  align-items: flex-end;
  flex-direction: row;
  padding-top: 5px;
`;
exports.Dot = native_1.default.Text `
  border-radius: 6px;
  width: 12px;
  display: flex;
  height: 12px;
  background: ${(props) => props.active ? props.theme.color.primary : props.theme.color.grey.eight};
  border: ${(props) => (props.active ? 'none' : '1px solid #D0D0D0')};
  overflow: hidden;
  margin: 0 5px;
`;
